import $ from "jquery";
import merge from "lodash/merge";

// timeout: 8000, speed: 2000, pause: true, selector: '> div'
const cycler = (el, opts) => {
  opts = merge(
    {
      timeout: 6000,
      speed: 2000,
      autoHeight: true,
      selector: "> div"
    },
    opts
  );

  const $container = $(el);
  const isVisible = $container.is(":visible");

  const $slides = $container.find(opts.selector);

  const height = $slides.get().reduce((h, slide) => {
    h = Math.max(h, slide.offsetHeight);
    return h;
  }, 0);

  if (opts.autoHeight) {
    $container.height(height).css("maxHeight", height);
    $slides.height(height).css("maxHeight", height);
  }

  $slides.css({
    position: "absolute"
  });

  // eslint-disable-next-line prefer-destructuring
  const length = $slides.length;
  let idx = 0;
  const transitionSlide = () => {
    if (!isVisible) {
      return;
    }
    $slides.css("transition", `visibility ${opts.speed}ms, opacity ${opts.speed}ms linear`);
    const $current = $($slides.get(idx));

    if (idx + 1 === length) {
      idx = 0;
    } else {
      // eslint-disable-next-line no-plusplus
      idx++;
    }
    const $next = $($slides.get(idx));

    $current.css({
      visibility: "hidden",
      opacity: 0
    });
    $next.css({
      visibility: "visible",
      opacity: 1
    });

    setTimeout(transitionSlide, opts.timeout);
  };

  setTimeout(transitionSlide, opts.timeout);
};

$.fn.cycle = function cycle(opts) {
  return $(this).each(function e() {
    cycler(this, opts);
  });
};

export default cycler;
